import { StackView, Button } from '@planningcenter/tapestry-react';
import React from 'react';
import colors from '../../vendor/topbar/colors.js';
import { DrawerHeading } from '../../vendor/topbar/components/drawer_heading.js';
import { ChannelMetas } from '../channel_metas.js';
import { useMessageListScrollShadows } from './hooks/use_message_list_scroll_shadows.js';

const InjectableCustomHeader = ({ channel, closeDrawer, setOverflowBottom, setOverflowTop, switchToChannelDetailsView, switchToChannelListView, title, }) => {
    const { headerRef } = useMessageListScrollShadows({
        setOverflowBottom,
        setOverflowTop,
    });
    return (React.createElement(CustomHeader, { channel: channel, closeDrawer: closeDrawer, innerRef: headerRef, switchToChannelDetailsView: switchToChannelDetailsView, switchToChannelListView: switchToChannelListView, title: title }));
};
const CustomHeader = ({ channel, closeDrawer, switchToChannelDetailsView, switchToChannelListView, title, innerRef = null, }) => {
    return (React.createElement(StackView, { axis: "horizontal", backgroundColor: "surface", innerRef: innerRef, left: 0, padding: 2, paddingTop: 1, position: "absolute", right: 0, spacing: 1, top: 0, zIndex: 5 },
        React.createElement(Button, { alignSelf: "baseline", "aria-label": "Switch to chat list", icon: {
                color: colors.lightNeutral12,
                name: "general.leftChevron",
            }, marginTop: 0.25, onClick: switchToChannelListView, size: "md", title: "Back to chat list", variant: "naked" }),
        React.createElement(StackView, { shrink: 1 },
            React.createElement(DrawerHeading, { truncate: true }, title),
            React.createElement(ChannelMetas, { channel: channel })),
        React.createElement(StackView, { alignment: "start", axis: "horizontal", marginLeft: "auto", spacing: 0.25 },
            React.createElement(Button, { "aria-label": "Switch to conversation details", icon: {
                    color: colors.lightNeutral12,
                    name: "general.cog",
                }, onClick: switchToChannelDetailsView, size: "md", title: "Conversation details", variant: "naked" }),
            React.createElement(Button, { "aria-label": "Close drawer", icon: {
                    color: colors.lightNeutral12,
                    name: "general.x",
                }, onClick: closeDrawer, size: "md", title: "Close drawer", variant: "naked" }))));
};

export { CustomHeader, InjectableCustomHeader };
//# sourceMappingURL=custom_header.js.map
